export default function () {
  ;(function (document, tag) {
    const script = document.createElement(tag)
    const element = document.getElementsByTagName('body')[0]
    script.src = 'https://acsbap.com/apps/app/assets/js/acsb.js'
    script.async = true
    script.defer = true
    ;(typeof element === 'undefined'
      ? document.getElementsByTagName('html')[0]
      : element
    ).appendChild(script)
    script.onload = function () {
      window.acsbJS.init({
        statementLink: '',
        feedbackLink: '',
        footerHtml: '',
        hideMobile: true,
        hideTrigger: true,
        language: 'en',
        position: 'left',
        leadColor: '#e10098',
        triggerColor: '#e10098',
        triggerRadius: '50%',
        triggerPositionX: 'left',
        triggerPositionY: 'bottom',
        triggerIcon: 'default',
        triggerSize: 'small',
        triggerOffsetX: 8,
        triggerOffsetY: 8,
        mobile: {
          triggerSize: 'small',
          triggerPositionX: 'right',
          triggerPositionY: 'bottom',
          triggerOffsetX: 0,
          triggerOffsetY: 0,
          triggerRadius: '0'
        }
      })
    }
  })(document, 'script')
}
